import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import BatchDataConfigViewForm from './BatchDataConfigViewForm'
import BatchDataConfigEditForm from './BatchDataConfigEditForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import BatchDataConfigKeys from 'src/constants/locale/key/BatchDataConfig'

const { CngTabs } = components


function EditPage({ showNotification }) {
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.BATCH_DATA_CONFIG])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let batchDataConfig = translate(
      Namespace.BATCH_DATA_CONFIG,
      BatchDataConfigKeys.TITLE
    )

    return {
      batchDataConfig
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <BatchDataConfigViewForm
              showNotification={showNotification}
              id={id}
              onFetchPreSuccess={(datum) => {
              }}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.batchDataConfig,
              tabContent: (
                <BatchDataConfigEditForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default EditPage